/**
 * The emoji palette offered wherever a food gets one: the item editor, bulk
 * add's review rows and the admin's starter pantry.
 *
 * Grouped roughly by category so the row you want is near the top. It had no
 * hot dog, which is how one ended up in the pantry as the letter H.
 */
export const SUGGESTED_EMOJI = [
  // Mains
  '🥪','🍔','🌭','🌮','🌯','🫔','🥙','🧆','🍕','🍝','🍜','🍛','🍚','🍱','🥘','🍲','🥟','🍤','🍣','🍙',
  '🥯','🥐','🍞','🥖','🫓','🥞','🧇','🍳','🥚','🧀','🍖','🍗','🥩','🥓','🐟',
  // Fruit
  '🍓','🍇','🍎','🍏','🍌','🍈','🍉','🍒','🥝','🥭','🍊','🍋','🍑','🍐','🍍','🥥','🫐',
  // Veg
  '🥒','🌽','🥑','🥕','🥦','🍅','🫑','🥬','🧅','🍄','🫛','🫒','🥗','🍠','🍟',
  // Sides, snacks and sweet things
  '🥨','🍘','🍿','🥜','🫘','🧁','🍪','🍫','🍬','🍩','🍰','🧊','🍮','🍨','🍧','🥧','🥠','🍯','🥫',
  // Drinks and containers
  '🥛','🧃','🥤','🧋','🥣','🥡','🍽️',
]
